<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div class="main blog-landing" rel="main">
			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link" @click="goHome">
								<a ></a>
							</li>
							<li class="nav-link">
								<span>Insight</span>
							</li>
							<li class="nav-link">
								<span>Podcasts</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="page-header-background-image page-header-background-image-forced-height background-image-desktop2">
				<div class="background-image background-image-desktop"></div>
			</div>
			<div class="page-wrapper page-header headline-module__page-header headline-module__image-background">
				<div class="content">
					<h1 class="page-title">Firm Podcasts</h1>
					<h3 class="page-subtitle">Listen as our experts discuss the hottest topics in the legal sphere
					</h3>
				</div>
			</div>
			<div class="page-wrapper">
				<h2 class="header" data-bind="html: BlogsSubTitle">Featured Podcasts</h2>
				<!-- ko if: blogTopics() && blogTopics().length > 0 -->
				<!-- /ko -->
			</div>
			<div class="featured-insights">
				<div class="featured-insights__collection">
					<div class="featured-insights__tile promo-content-tile">
						<a class="promo-content-link" target="_blank">
							<div class="container-table">
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">
											Podcasts on InsightPlus
										</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">Gain insight into
											the important issues by listening to our podcasts on our dedicated
											knowledge site.&nbsp;</div>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
						<a class="promo-content-link">
							<div class="container-table">
								<div class="pcm-standard-background-image c-bg1">
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">FT
											Due Diligence Series
										</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">Key developments
											and issues shaping the future of global transactions</div>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
						<a class="promo-content-link" >
							<div class="container-table">
								<div class="pcm-standard-background-image c-bg2" >
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">
											Solutions for a
											Connected World: A Podcast Series</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">This podcast
											series uncovers forward-looking insights from Baker McKenzie and
											industry experts on driving growth in your organization.</div>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
						<a class="promo-content-link" >
							<div class="container-table">
								<div class="pcm-standard-background-image c-bg3">
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">
											Need to Know: The Asia
											Pacific Employment Podcast Series</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">This podcast
											discusses recent legislative changes, notable cases and other employment
											law hot topics in Asia Pacific.</div>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
						<a class="promo-content-link">
							<div class="container-table">
								<div class="pcm-standard-background-image c-bg4">
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">
											Funds Tax Talks</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">Baker McKenzie's
											tax funds podcast series, highlights sector and juridisctional-specific
											issues and trends that affect the gamut of funds.</div>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
						<a class="promo-content-link" >
							<div class="container-table">
								<div class="pcm-standard-background-image c-bg5">
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">
											Talking M&amp;A</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">From navigating
											the complexities of carve-outs to cross-border trends, gain expert
											insights and uncover key topics in a complex transactional landscape.
										</div>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
						<a class="promo-content-link">
							<div class="container-table">
								<div class="pcm-standard-background-image c-bg6">
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">
											Connect on Tech Podcast
										</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">Up-to-the-minute
											insights on data protection, cybersecurity, information management and
											more</div>
									</div>
								</div>
							</div>
						</a>
					</div>

					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
						<a class="promo-content-link">
							<div class="container-table">
								<div class="pcm-standard-background-image c-bg7">
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline" data-bind="html: blogTitle, visible: blogTitle">
											FInsight: The Global
											Financial Institutions Industry Podcast</div>
										<div class="content-summary"
											data-bind="html: blogOverview, visible: blogOverview">Recommendations
											and insights into sectoral developments and trends in financial
											institutions</div>
									</div>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="global-footer">
		    <div class="footer-nav hide-print">
		            <ul class="utility-links">
		                        <li class="utility-link"><a>Disclaimers</a></li>
		                        <li class="utility-link"><a>Privacy &amp; Cookies Statement</a></li>
		                        <li class="utility-link"><a class="ot-sdk-show-settings" title="Manage Choices">Cookie Preferences</a></li>
		                        <li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
		                        <li class="utility-link"><a>Contact Us</a></li>
		                        <li class="utility-link"><a >Media Contacts</a></li>
		                        <li class="utility-link"><a >Blogs</a></li>
		                        <li class="utility-link"><a>BM Online</a></li>
		            </ul>
		        
		    </div>
		    <div class="copyright">
		<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>    </div>
		</div>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			goHome() {
				this.$router.replace('/');
			},
		}
	}
</script>

<style src="@/assets/main.css"  scoped></style>
<style lang='scss' scoped>
	.body-container {
		width: 100%;
		/* min-width: 1280px; */
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}
	.main {
		padding-top: 82px;
	}
	.page-header-options {
	    background: linear-gradient(287.72deg, #ad122a -2.45%, #790123 185.33%);
	    padding: 0.375em 0;
	    text-align: right;
	}
	.page-header-options .page-header-breadcrumb {
	    padding-right: 1.5em;
	    padding-left: 1.5em;
	    margin-left: auto;
	    margin-right: auto;
		height: 25px;
	}
	.breadcrumb-nav {
	    padding: 0.375em 0;
	}
	.page-header-options .breadcrumb-nav {
	    float: left;
	    text-align: left;
	    padding: 0;
	}
	.breadcrumb-nav .nav-links {
	    list-style-type: none;
	    white-space: nowrap;
	    overflow: hidden;
	    display: block;
	    text-overflow: ellipsis;
		margin: 0;
		padding: 0;
	}
	.breadcrumb-nav .nav-link {
	    display: inline;
	    color: #FFF;
	    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    font-size: 0.875em;
		letter-spacing: 1px;
		
		.icon-shouye {
			color: #fff;
			font-size: 15px;
			cursor: pointer;
		}
		
		.icon-xiangyou1 {
			font-size: 13px;
			margin: 0 5px;
		}
	}
	a {
	    color: #ad122a;
	    transition: color 0.4s, background-color 0.4s;
	}
	.breadcrumb-nav .nav-link a {
	    color: inherit;
	}
	.breadcrumb-nav .nav-link:first-of-type a {
	    font-size: 0;
	}
	.page-header-background-image {
	    position: relative;
	    padding: 8.125em 0 9.375em;
	}
	.page-header-background-image.page-header-background-image-forced-height {
	    height: 6vh;
	}
	.page-header-background-image .background-image {
	    position: absolute;
	    top: 0;
	    left: 0;
	    height: 100%;
	    width: 100%;
	    background-repeat: no-repeat;
	    background-size: cover;
	    background-position: 50% 50%;
	}
	.blog-landing .background-image {
	    z-index: -10;
	}
	.page-header-background-image.page-header-background-image-forced-height .background-image {
	    background-position: 50% 0%;
	}
	.background-image-desktop2 {
		background-image: url('../../assets/test/61.jpeg');
		background-size: 100% 100%;
	}
	.page-wrapper {
	    max-width: 79.875em;
	    padding-right: 1.5em;
	    padding-left: 1.5em;
	    margin-left: auto;
	    margin-right: auto;
	}
	.headline-module__page-header {
	    -ms-flex-align: center;
	    align-items: center;
	    margin-top: -70px;
	}
	.page-header {
	    padding: 4.375em 0;
	    background-size: cover;
	    border-bottom: 1px solid #cececd;
	}
	.headline-module__page-header.headline-module__image-background {
	    background-color: #FFF;
	    position: relative;
	    text-align: center;
	    padding: 2.8125rem 2.5rem;
	}
	.headline-module__page-header.headline-module__image-background.page-header {
	    border-bottom: none;
	}
	.c-bg1 {
		background: url('../../assets/test/61.jpeg');
		background-size: cover;
	}
	.c-bg2 {
		background: url('../../assets/test/62.jpeg');
		background-size: cover;
	}
	.c-bg3 {
		background: url('../../assets/test/63.webp');
		background-size: cover;
	}
	.c-bg4 {
		background: url('../../assets/test/64.jpeg');
		background-size: cover;
	}
	.c-bg5 {
		background: url('../../assets/test/65.webp');
		background-size: cover;
	}
	.c-bg6 {
		background: url('../../assets/test/66.jpeg');
		background-size: cover;
	}
	.c-bg7 {
		background: url('../../assets/test/67.jpeg');
		background-size: cover;
	}
	.promo-content-tile .container-table {
		height: auto;
	}
	@media screen and (max-width: 47.9375em){
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.main {
			padding-top: 63px;
		}
		.promo-content-tile.promo-content-tile--has-image .promo-content-link .container-row{
		    margin: 0 20px;
		    padding: 15px;
		    bottom: -14px;
		    width: calc(87% - 40px);
		}
	}
</style>
